export default {
    "en": {
        "photoFaceSwap": {
            "title": "Free AI Photo Face Swap Online | WeryAI",
            "description": "Swap faces in photos instantly with AI. Create funny memes, artistic portraits, or just have fun. Realistic results in seconds. Free credits to start!",
            "keywords": "ai face swap, face swap online, photo face changer, reface free, replace face in image, deepfake photo, meme maker ai",
            "og_title": "Free AI Photo Face Swap Online | WeryAI",
            "og_description": "Swap faces in photos instantly with AI. Create funny memes, artistic portraits, or just have fun. Realistic results in seconds. Free credits to start!",
            "twitter_title": "Free AI Photo Face Swap Online | WeryAI",
            "twitter_description": "Swap faces in photos instantly with AI. Create funny memes, artistic portraits, or just have fun. Realistic results in seconds. Free credits to start!",
            "page": {
                "title1": "Free AI Photo Face Swap",
                "title2": "Want to see yourself as an astronaut, a movie star, or in a classic painting? Upload a base photo and a target face, and let our AI seamlessly blend facial features, lighting, and skin tones for a hyper-realistic face swap in seconds.",
                "faq": [
                    {
                        "question": "Can I use WeryAI Photo Face Swap for free?",
                        "answer": "Yes! New users get free credits on signup -- no credit card required. You can also earn more free credits every day through daily check-in, completing tasks, and inviting friends, so you can keep using the Photo Face Swap without an upfront payment."
                    },
                    {
                        "question": "Is my data safe?",
                        "answer": "Absolutely. We prioritize your privacy. The photos you upload are used solely for the swapping process and are automatically deleted from our servers after a short period."
                    },
                    {
                        "question": "How do I get the best results?",
                        "answer": "For the most realistic swap, ensure both the \"Base Image\" and \"Face Image\" are clear, front-facing, and have good lighting. Avoid photos where the face is obscured by hair or hands."
                    },
                    {
                        "question": "Can I swap faces in group photos?",
                        "answer": "Currently, our tool focuses on single-face swapping precision. For group photos, please crop the image or use our upcoming multi-face feature."
                    },
                    {
                        "question": "Can I use this for memes?",
                        "answer": "Yes! It's perfect for creating funny memes. Swap your friend's face onto a movie poster or a viral meme template instantly. For video face swaps, check out our <a href=\"/video-face-swap\">Video Face Swap</a> tool."
                    }
                ]
            },
            "faq": [
                {
                    "question": "Can I use WeryAI Photo Face Swap for free?",
                    "answer": "Yes! New users get free credits on signup -- no credit card required. You can also earn more free credits every day through daily check-in, completing tasks, and inviting friends, so you can keep using the Photo Face Swap without an upfront payment."
                },
                {
                    "question": "Is my data safe?",
                    "answer": "Absolutely. We prioritize your privacy. The photos you upload are used solely for the swapping process and are automatically deleted from our servers after a short period."
                },
                {
                    "question": "How do I get the best results?",
                    "answer": "Ensure both photos are clear, front-facing, and well-lit. Avoid faces obscured by hair or glasses."
                }
            ],
            "feature_title1": "Artistic Masterpieces",
            "feature_desc1": "Time Travel: Swap your face into classic oil paintings like the Mona Lisa or Girl with a Pearl Earring. Create unique vintage avatars instantly.",
            "feature_title2": "Professional & Cool Avatars",
            "feature_desc2": "Dream Jobs: See yourself in a racing suit, astronaut gear, or business attire without buying the costume. Perfect for creating standout profile pictures.",
            "feature_title3": "Hyper-Realistic Blending",
            "feature_desc3": "No \"Paste\" Effect: Unlike simple cut-and-paste tools, WeryAI analyzes the angle, lighting, and skin texture to ensure the swapped face looks 100% natural, not fake.",
            "howto": {
                "name": "How to Swap Faces in Photos Online",
                "step1": {
                    "name": "Upload Base Image",
                    "text": "Upload the photo containing the body/scene you want to use (e.g., an astronaut)."
                },
                "step2": {
                    "name": "Upload Face Image",
                    "text": "Upload a photo of the face you want to swap onto the body."
                },
                "step3": {
                    "name": "Generate",
                    "text": "Click 'Create'. The AI will seamlessly blend the new face into the base image."
                }
            }
        }
    },
    "zh": {
        "photoFaceSwap": {
            "title": "免费 AI 照片换脸 - 在线人脸替换 | WeryAI",
            "description": "使用 WeryAI 的免费 AI 换脸工具，瞬间在照片中交换人脸。轻松做搞笑表情包、艺术肖像（如蒙娜丽莎），或高真实感的职业头像。100% 隐私安全。",
            "keywords": "图片换脸, 在线换脸, 照片换脸, 人脸替换, AI 换脸, deepfake 照片, meme 生成",
            "og_title": "免费 AI 照片换脸 - 在线人脸替换 | WeryAI",
            "og_description": "使用 WeryAI 的免费 AI 换脸工具，瞬间在照片中交换人脸。轻松做搞笑表情包、艺术肖像（如蒙娜丽莎），或高真实感的职业头像。100% 隐私安全。",
            "twitter_title": "免费 AI 照片换脸 - 在线人脸替换 | WeryAI",
            "twitter_description": "使用 WeryAI 的免费 AI 换脸工具，瞬间在照片中交换人脸。轻松做搞笑表情包、艺术肖像（如蒙娜丽莎），或高真实感的职业头像。100% 隐私安全。",
            "page": {
                "title1": "免费 AI 图片换脸",
                "title2": "想把自己变成宇航员、电影明星，或出现在经典名画里吗？上传一张底图和一张人脸图，我们的 AI 会在几秒钟内无缝融合五官、光线和肤色，生成超真实的换脸效果。",
                "faq": [
                    {
                        "question": "WeryAI 换脸可以免费使用吗？",
                        "answer": "可以！新用户注册即可获得免费积分，无需信用卡。之后还可以通过每日签到、完成任务和邀请好友持续获得免费积分，因此无需预付费也能继续使用照片换脸功能。"
                    },
                    {
                        "question": "我的数据安全吗？",
                        "answer": "当然安全。我们非常重视隐私。你上传的照片只用于换脸处理，并会在短时间后自动从服务器删除。"
                    },
                    {
                        "question": "如何获得最好的换脸效果？",
                        "answer": "为了更真实，请确保“底图”和“人脸图”都清晰、正面且光线充足。避免脸部被头发或手遮挡的照片。"
                    },
                    {
                        "question": "可以在多人合照里换脸吗？",
                        "answer": "目前我们的工具更专注于单人脸的高精度换脸。多人合照建议先裁剪，或等待我们即将推出的多人脸功能。"
                    },
                    {
                        "question": "可以用来做表情包吗？",
                        "answer": "当然可以！非常适合做搞笑表情包。把朋友的脸换到电影海报或热门梗图模板上，立刻出图。"
                    }
                ]
            },
            "faq": [
                {
                    "question": "WeryAI 换脸可以免费使用吗？",
                    "answer": "可以！新用户注册即可获得免费积分，无需信用卡。之后还可以通过每日签到、完成任务和邀请好友持续获得免费积分，因此无需预付费也能继续使用照片换脸功能。"
                },
                {
                    "question": "我的数据安全吗？",
                    "answer": "当然安全。我们非常重视隐私。你上传的照片只用于换脸处理，并会在短时间后自动从服务器删除。"
                },
                {
                    "question": "如何获得最好的换脸效果？",
                    "answer": "请确保两张照片清晰、正面且光线良好；尽量避免头发或眼镜遮挡面部。"
                }
            ],
            "feature_title1": "艺术名作体验",
            "feature_desc1": "穿越时空：把你的脸换进《蒙娜丽莎》或《戴珍珠耳环的少女》等经典油画中，瞬间生成独特的复古头像。",
            "feature_title2": "职业与酷炫头像",
            "feature_desc2": "梦想职业：无需购买服装，就能看到自己穿着赛车服、宇航服或商务正装的样子，轻松做出更吸睛的头像。",
            "feature_title3": "超真实自然融合",
            "feature_desc3": "不再是“贴上去”的效果：不同于简单抠图粘贴，WeryAI 会分析角度、光线和皮肤纹理，让换脸看起来 100% 自然不假。",
            "howto": {
                "name": "如何在线进行照片换脸",
                "step1": {
                    "name": "上传基础图片",
                    "text": "上传包含您想要使用的身体/场景的照片（例如宇航员）。"
                },
                "step2": {
                    "name": "上传面部图片",
                    "text": "上传您想要替换到身体上的面部照片。"
                },
                "step3": {
                    "name": "生成",
                    "text": "点击“创建”。AI 将把新面孔无缝融合到基础图片中。"
                }
            }
        }
    },
    "ja": {
        "photoFaceSwap": {
            "title": "無料 AI 写真顔交換オンライン | WeryAI",
            "description": "WeryAIの無料AI顔交換ツールで、写真の顔を瞬時に交換。面白いミーム、芸術的な肖像画（モナ・リザ）、または高リアリズムのプロフェッショナルなヘッドショットを作成。100%プライベートで安全。",
            "keywords": "ai顔交換, オンライン顔交換, 写真顔チェンジャー, 無料リフェース, 画像で顔を置き換え, ディープフェイク写真, aiミームメーカー",
            "og_title": "無料 AI 写真顔交換オンライン | WeryAI",
            "og_description": "WeryAIの無料AI顔交換ツールで、写真の顔を瞬時に交換。面白いミーム、芸術的な肖像画（モナ・リザ）、または高リアリズムのプロフェッショナルなヘッドショットを作成。100%プライベートで安全。",
            "twitter_title": "無料 AI 写真顔交換オンライン | WeryAI",
            "twitter_description": "WeryAIの無料AI顔交換ツールで、写真の顔を瞬時に交換。面白いミーム、芸術的な肖像画（モナ・リザ）、または高リアリズムのプロフェッショナルなヘッドショットを作成。100%プライベートで安全。",
            "page": {
                "title1": "無料AI写真顔交換",
                "title2": "宇宙飛行士、映画スター、または古典的な絵画の中の自分を見てみたいですか？ベース写真とターゲット顔をアップロードすると、AIが顔の特徴、照明、肌のトーンをシームレスにブレンドし、数秒で超リアルな顔交換を実現します。",
                "faq": [
                    {
                        "question": "WeryAI顔交換は無料で使用できますか？",
                        "answer": "はい！新規ユーザーは登録時にクレジットカード不要で無料クレジットを受け取れます。さらに、毎日のチェックイン、タスク完了、友達招待でも無料クレジットを継続的に獲得できるため、前払いなしで写真顔交換を使い続けられます。"
                    },
                    {
                        "question": "私のデータは安全ですか？",
                        "answer": "絶対に安全です。私たちはあなたのプライバシーを最優先にしています。アップロードした写真は交換プロセスのみに使用され、短期間後にサーバーから自動的に削除されます。"
                    },
                    {
                        "question": "最高の結果を得るにはどうすればよいですか？",
                        "answer": "最もリアルな交換のために、「ベース画像」と「顔画像」の両方が明確で、正面を向いており、良好な照明があることを確認してください。顔が髪や手で隠れている写真は避けてください。"
                    },
                    {
                        "question": "集合写真で顔を交換できますか？",
                        "answer": "現在、私たちのツールは単一顔交換の精度に焦点を当てています。集合写真の場合は、画像をクロップするか、今後の複数顔機能をご利用ください。"
                    },
                    {
                        "question": "ミームに使用できますか？",
                        "answer": "はい！面白いミームを作成するのに最適です。友達の顔を映画ポスターやバイラルミームテンプレートに瞬時に交換できます。"
                    }
                ]
            },
            "faq": [
                {
                    "question": "WeryAI顔交換は無料で使用できますか？",
                    "answer": "はい！新規ユーザーは登録時にクレジットカード不要で無料クレジットを受け取れます。さらに、毎日のチェックイン、タスク完了、友達招待でも無料クレジットを継続的に獲得できるため、前払いなしで写真顔交換を使い続けられます。"
                },
                {
                    "question": "私のデータは安全ですか？",
                    "answer": "絶対に安全です。私たちはあなたのプライバシーを最優先にしています。アップロードした写真は交換プロセスのみに使用され、短期間後にサーバーから自動的に削除されます。"
                },
                {
                    "question": "最高の結果を得るにはどうすればよいですか？",
                    "answer": "両方の写真が明確で、正面を向いており、十分に照明されていることを確認してください。髪や眼鏡で顔が隠れている写真は避けてください。"
                }
            ],
            "feature_title1": "芸術的な傑作",
            "feature_desc1": "タイムトラベル：モナ・リザや真珠の耳飾りの少女などの古典的な油絵に顔を交換。ユニークなビンテージアバターを瞬時に作成。",
            "feature_title2": "プロフェッショナルでクールなアバター",
            "feature_desc2": "夢の職業：コスチュームを購入することなく、レーシングスーツ、宇宙飛行士の装備、またはビジネススーツの自分を見ることができます。目立つプロフィール写真を作成するのに最適です。",
            "feature_title3": "超リアルなブレンディング",
            "feature_desc3": "「貼り付け」効果なし：単純な切り貼りツールとは異なり、WeryAIは角度、照明、肌の質感を分析し、交換された顔が100%自然で、偽物に見えないようにします。",
            "howto": {
                "name": "オンラインで写真の顔を入れ替える方法",
                "step1": {
                    "name": "ベース画像をアップロード",
                    "text": "使用したい体/シーン（例：宇宙飛行士）が含まれる写真をアップロードします。"
                },
                "step2": {
                    "name": "顔画像をアップロード",
                    "text": "体に入れ替えたい顔の写真をアップロードします。"
                },
                "step3": {
                    "name": "生成",
                    "text": "「作成」をクリックします。AIが新しい顔をベース画像にシームレスに合成します。"
                }
            }
        }
    },
    "ko": {
        "photoFaceSwap": {
            "title": "무료 AI 사진 얼굴 교체 온라인 | WeryAI",
            "description": "WeryAI의 무료 AI 얼굴 교체기로 사진에서 얼굴을 즉시 바꿔보세요. 웃긴 밈, 예술적인 초상화(모나리자), 또는 고현실감 프로필 사진을 만들 수 있습니다. 100% 프라이버시 보호 및 안전.",
            "keywords": "AI 얼굴 바꾸기, 온라인 얼굴 교체, 사진 얼굴 교체, 얼굴 변경, 딥페이크 사진, 밈 만들기, 얼굴 스왑",
            "og_title": "무료 AI 사진 얼굴 교체 온라인 | WeryAI",
            "og_description": "WeryAI의 무료 AI 얼굴 교체기로 사진에서 얼굴을 즉시 바꿔보세요. 웃긴 밈, 예술적인 초상화(모나리자), 또는 고현실감 프로필 사진을 만들 수 있습니다. 100% 프라이버시 보호 및 안전.",
            "twitter_title": "무료 AI 사진 얼굴 교체 온라인 | WeryAI",
            "twitter_description": "WeryAI의 무료 AI 얼굴 교체기로 사진에서 얼굴을 즉시 바꿔보세요. 웃긴 밈, 예술적인 초상화(모나리자), 또는 고현실감 프로필 사진을 만들 수 있습니다. 100% 프라이버시 보호 및 안전.",
            "page": {
                "title1": "무료 AI 사진 얼굴 바꾸기",
                "title2": "우주비행사, 영화 스타, 혹은 클래식 명화 속 내 모습을 보고 싶나요? 베이스 사진과 얼굴 사진을 업로드하면, AI가 얼굴 특징·조명·피부 톤을 자연스럽게 블렌딩해 몇 초 만에 초현실적인 얼굴 교체를 만들어 줍니다.",
                "faq": [
                    {
                        "question": "WeryAI 얼굴 교체를 무료로 사용할 수 있나요?",
                        "answer": "네. 신규 사용자는 가입 시 신용카드 없이 무료 크레딧을 받을 수 있습니다. 또한 매일 체크인, 작업 완료, 친구 초대를 통해 무료 크레딧을 더 받을 수 있어 선결제 없이도 계속 사용할 수 있습니다."
                    },
                    {
                        "question": "내 데이터는 안전한가요?",
                        "answer": "물론입니다. 우리는 개인정보를 최우선으로 합니다. 업로드한 사진은 얼굴 교체 과정에만 사용되며, 짧은 시간 후 서버에서 자동 삭제됩니다."
                    },
                    {
                        "question": "최고의 결과를 얻으려면 어떻게 해야 하나요?",
                        "answer": "가장 자연스럽게 바꾸려면 “베이스 이미지”와 “얼굴 이미지”가 모두 선명하고 정면이며 조명이 좋은지 확인하세요. 머리카락이나 손이 얼굴을 가린 사진은 피하세요."
                    },
                    {
                        "question": "단체 사진에서도 얼굴을 바꿀 수 있나요?",
                        "answer": "현재는 단일 얼굴 교체 정확도에 집중하고 있습니다. 단체 사진은 먼저 크롭하거나, 곧 출시될 다중 얼굴 기능을 이용해 주세요."
                    },
                    {
                        "question": "밈(짤)로도 쓸 수 있나요?",
                        "answer": "네! 웃긴 밈 제작에 딱입니다. 친구 얼굴을 영화 포스터나 유행 밈 템플릿에 즉시 교체해 보세요."
                    }
                ]
            },
            "faq": [
                {
                    "question": "WeryAI 얼굴 교체를 무료로 사용할 수 있나요?",
                    "answer": "네. 신규 사용자는 가입 시 신용카드 없이 무료 크레딧을 받을 수 있습니다. 또한 매일 체크인, 작업 완료, 친구 초대를 통해 무료 크레딧을 더 받을 수 있어 선결제 없이도 계속 사용할 수 있습니다."
                },
                {
                    "question": "내 데이터는 안전한가요?",
                    "answer": "물론입니다. 업로드한 사진은 교체 과정에만 사용되며, 짧은 시간 후 서버에서 자동 삭제됩니다."
                },
                {
                    "question": "최고의 결과를 얻으려면 어떻게 해야 하나요?",
                    "answer": "두 사진 모두 선명하고 정면이며 조명이 좋아야 합니다. 머리카락이나 안경이 얼굴을 가리는 사진은 피하세요."
                }
            ],
            "feature_title1": "예술 작품 스타일",
            "feature_desc1": "시간여행: 모나리자나 진주 귀걸이를 한 소녀 같은 고전 명화에 내 얼굴을 바꿔 넣어, 독특한 빈티지 아바타를 즉시 만들어 보세요.",
            "feature_title2": "프로필에 딱 맞는 아바타",
            "feature_desc2": "드림 직업 콘셉트: 레이싱 슈트, 우주복, 비즈니스 정장 등—옷을 사지 않아도 내 모습을 확인할 수 있어요. 눈에 띄는 프로필 사진에 완벽합니다.",
            "feature_title3": "초현실적 자연 합성",
            "feature_desc3": "붙여넣기 느낌 0: 단순한 잘라붙이기와 달리, WeryAI는 각도·조명·피부 질감을 분석해 얼굴이 100% 자연스럽게 보이도록 만듭니다.",
            "howto": {
                "name": "온라인으로 사진 속 얼굴 바꾸는 방법",
                "step1": {
                    "name": "기본 이미지 업로드",
                    "text": "사용하고 싶은 몸/배경이 포함된 사진(예: 우주비행사)을 업로드하세요."
                },
                "step2": {
                    "name": "얼굴 이미지 업로드",
                    "text": "몸에 합성할 얼굴 사진을 업로드하세요."
                },
                "step3": {
                    "name": "생성",
                    "text": "'만들기'를 클릭하세요. AI가 새로운 얼굴을 기본 이미지에 자연스럽게 합성합니다."
                }
            }
        }
    },
    "es": {
        "photoFaceSwap": {
            "title": "Cambiar Caras en Fotos con IA Gratis | WeryAI",
            "description": "Cambia rostros en fotos al instante con el Face Swapper IA Gratis de WeryAI. Crea memes divertidos, retratos artísticos (Mona Lisa) o headshots profesionales con gran realismo. 100% privado y seguro.",
            "keywords": "face swap IA, intercambio de rostros online, cambiador de cara, reface gratis, reemplazar cara en imagen, deepfake foto, creador de memes IA",
            "og_title": "Cambiar Caras en Fotos con IA Gratis | WeryAI",
            "og_description": "Cambia rostros en fotos al instante con el Face Swapper IA Gratis de WeryAI. Crea memes divertidos, retratos artísticos (Mona Lisa) o headshots profesionales con gran realismo. 100% privado y seguro.",
            "twitter_title": "Cambiar Caras en Fotos con IA Gratis | WeryAI",
            "twitter_description": "Cambia rostros en fotos al instante con el Face Swapper IA Gratis de WeryAI. Crea memes divertidos, retratos artísticos (Mona Lisa) o headshots profesionales con gran realismo. 100% privado y seguro.",
            "page": {
                "title1": "Intercambio de Rostros en Fotos con IA Gratis",
                "title2": "¿Quieres verte como astronauta, estrella de cine o dentro de una pintura clásica? Sube una foto base y un rostro objetivo, y deja que nuestra IA mezcle rasgos faciales, iluminación y tonos de piel para un face swap hiperrealista en segundos.",
                "faq": [
                    {
                        "question": "¿WeryAI Face Swap es gratis?",
                        "answer": "¡Sí! Los nuevos usuarios reciben créditos gratis al registrarse, sin tarjeta de crédito. Además, puedes seguir ganando créditos gratis con el check-in diario, completando tareas e invitando amigos, para que puedas usar el intercambio de rostros sin pagar por adelantado."
                    },
                    {
                        "question": "¿Mis datos están seguros?",
                        "answer": "Totalmente. Priorizamos tu privacidad. Las fotos que subes se usan solo para el proceso de intercambio y se eliminan automáticamente de nuestros servidores tras un corto periodo."
                    },
                    {
                        "question": "¿Cómo obtengo los mejores resultados?",
                        "answer": "Para un resultado más realista, asegúrate de que la “Imagen Base” y la “Imagen de Rostro” sean claras, de frente y con buena luz. Evita fotos donde el rostro esté tapado por cabello o manos."
                    },
                    {
                        "question": "¿Puedo intercambiar rostros en fotos grupales?",
                        "answer": "Actualmente nos enfocamos en la precisión de intercambio de un solo rostro. Para fotos grupales, recorta la imagen o espera nuestra próxima función de múltiples rostros."
                    },
                    {
                        "question": "¿Puedo usarlo para memes?",
                        "answer": "¡Sí! Es perfecto para crear memes divertidos. Cambia la cara de tu amigo en un póster de película o en una plantilla viral al instante."
                    }
                ]
            },
            "faq": [
                {
                    "question": "¿WeryAI Face Swap es gratis?",
                    "answer": "¡Sí! Los nuevos usuarios reciben créditos gratis al registrarse sin tarjeta. También puedes ganar más créditos con el check-in diario, tareas e invitaciones de amigos."
                },
                {
                    "question": "¿Mis datos están seguros?",
                    "answer": "Sí. Las fotos se usan solo para el intercambio y se eliminan automáticamente tras un corto periodo."
                },
                {
                    "question": "¿Cómo obtengo los mejores resultados?",
                    "answer": "Asegúrate de que ambas fotos sean claras, de frente y con buena iluminación. Evita rostros cubiertos por cabello o gafas."
                }
            ],
            "feature_title1": "Obras Maestras Artísticas",
            "feature_desc1": "Viaje en el Tiempo: Cambia tu rostro en pinturas clásicas como la Mona Lisa o La joven de la perla. Crea avatares vintage únicos al instante.",
            "feature_title2": "Avatares Profesionales y Cool",
            "feature_desc2": "Trabajos Soñados: Mírate con traje de carreras, equipo de astronauta o ropa formal sin comprar el disfraz. Perfecto para fotos de perfil que destacan.",
            "feature_title3": "Mezcla Hiperrealista",
            "feature_desc3": "Sin efecto “pegado”: A diferencia de herramientas de cortar y pegar, WeryAI analiza ángulo, luz y textura de piel para que el rostro se vea 100% natural, no falso.",
            "howto": {
                "name": "Cómo intercambiar caras en fotos online",
                "step1": {
                    "name": "Subir imagen base",
                    "text": "Sube la foto que contiene el cuerpo/escena que deseas usar (por ejemplo, un astronauta)."
                },
                "step2": {
                    "name": "Subir imagen de cara",
                    "text": "Sube una foto de la cara que deseas intercambiar en el cuerpo."
                },
                "step3": {
                    "name": "Generar",
                    "text": "Haz clic en 'Crear'. La IA combinará perfectamente la nueva cara en la imagen base."
                }
            }
        }
    },
    "fr": {
        "photoFaceSwap": {
            "title": "Échange de Visage Photo IA Gratuit | WeryAI",
            "description": "Échangez des visages sur vos photos instantanément avec l'outil Face Swap IA gratuit de WeryAI. Créez des memes, des portraits artistiques (Mona Lisa) ou des headshots professionnels ultra réalistes. 100% privé et sécurisé.",
            "keywords": "face swap IA, échange de visage en ligne, changeur de visage photo, reface gratuit, remplacer visage sur image, deepfake photo, créateur de memes IA",
            "og_title": "Échange de Visage Photo IA Gratuit | WeryAI",
            "og_description": "Échangez des visages sur vos photos instantanément avec l'outil Face Swap IA gratuit de WeryAI. Créez des memes, des portraits artistiques (Mona Lisa) ou des headshots professionnels ultra réalistes. 100% privé et sécurisé.",
            "twitter_title": "Échange de Visage Photo IA Gratuit | WeryAI",
            "twitter_description": "Échangez des visages sur vos photos instantanément avec l'outil Face Swap IA gratuit de WeryAI. Créez des memes, des portraits artistiques (Mona Lisa) ou des headshots professionnels ultra réalistes. 100% privé et sécurisé.",
            "page": {
                "title1": "Échange de Visage Photo IA Gratuit",
                "title2": "Envie de vous voir en astronaute, star de cinéma ou dans une peinture classique ? Téléchargez une photo de base et un visage cible : notre IA fusionne traits du visage, éclairage et tons de peau pour un face swap hyper réaliste en quelques secondes.",
                "faq": [
                    {
                        "question": "WeryAI Face Swap est-il gratuit ?",
                        "answer": "Oui ! Les nouveaux utilisateurs reçoivent des crédits gratuits à l'inscription, sans carte bancaire. Vous pouvez aussi continuer à obtenir des crédits gratuits grâce à la connexion quotidienne, aux tâches terminées et aux invitations d'amis, pour utiliser le face swap sans paiement anticipé."
                    },
                    {
                        "question": "Mes données sont-elles en sécurité ?",
                        "answer": "Absolument. Nous priorisons votre confidentialité. Les photos envoyées ne servent qu'au face swap et sont automatiquement supprimées de nos serveurs après un court délai."
                    },
                    {
                        "question": "Comment obtenir les meilleurs résultats ?",
                        "answer": "Pour un rendu réaliste, assurez-vous que l'“Image de base” et l'“Image visage” soient nettes, de face et bien éclairées. Évitez les photos où le visage est caché par les cheveux ou les mains."
                    },
                    {
                        "question": "Puis-je échanger des visages sur des photos de groupe ?",
                        "answer": "Pour le moment, notre outil se concentre sur la précision d'un seul visage. Pour les groupes, recadrez l'image ou utilisez notre future fonction multi-visages."
                    },
                    {
                        "question": "Puis-je l'utiliser pour des memes ?",
                        "answer": "Oui ! Parfait pour créer des memes amusants. Remplacez le visage d'un ami sur une affiche de film ou un modèle viral en un instant."
                    }
                ]
            },
            "faq": [
                {
                    "question": "WeryAI Face Swap est-il gratuit ?",
                    "answer": "Oui ! Les nouveaux utilisateurs reçoivent des crédits gratuits à l'inscription sans carte bancaire. Obtenez plus de crédits via la connexion quotidienne, les tâches et les invitations d'amis."
                },
                {
                    "question": "Mes données sont-elles en sécurité ?",
                    "answer": "Oui. Les photos ne sont utilisées que pour l'échange et sont supprimées automatiquement après un court délai."
                },
                {
                    "question": "Comment obtenir les meilleurs résultats ?",
                    "answer": "Assurez-vous que les deux photos soient nettes, de face et bien éclairées. Évitez les visages masqués par des cheveux ou des lunettes."
                }
            ],
            "feature_title1": "Chefs-d'œuvre Artistiques",
            "feature_desc1": "Voyage dans le temps : Insérez votre visage dans des tableaux classiques comme la Mona Lisa ou La Jeune Fille à la Perle. Créez instantanément des avatars vintage uniques.",
            "feature_title2": "Avatars Pros & Stylés",
            "feature_desc2": "Jobs de rêve : Voyez-vous en combinaison de course, tenue d'astronaute ou costume business sans acheter de déguisement. Idéal pour des photos de profil qui ressortent.",
            "feature_title3": "Fusion Hyper Réaliste",
            "feature_desc3": "Aucun effet “collé” : Contrairement aux outils copier-coller, WeryAI analyse l'angle, la lumière et la texture de peau pour un rendu 100% naturel, pas fake.",
            "howto": {
                "name": "Comment échanger des visages sur des photos en ligne",
                "step1": {
                    "name": "Télécharger l'image de base",
                    "text": "Téléchargez la photo contenant le corps/la scène que vous souhaitez utiliser (par ex. un astronaute)."
                },
                "step2": {
                    "name": "Télécharger l'image du visage",
                    "text": "Téléchargez une photo du visage que vous souhaitez échanger sur le corps."
                },
                "step3": {
                    "name": "Générer",
                    "text": "Cliquez sur « Créer ». L'IA fondra parfaitement le nouveau visage dans l'image de base."
                }
            }
        }
    },
    "de": {
        "photoFaceSwap": {
            "title": "KI-Foto-Gesichtstausch Online | WeryAI",
            "description": "Tauschen Sie Gesichter in Fotos sofort mit WeryAIs kostenlosem KI-Face-Swapper. Erstellen Sie lustige Memes, künstlerische Porträts (Mona Lisa) oder professionelle Headshots mit hoher Realistik. 100% privat & sicher.",
            "keywords": "KI face swap, gesicht online tauschen, foto gesicht wechseln, reface kostenlos, gesicht in bild ersetzen, deepfake foto, meme maker KI",
            "og_title": "KI-Foto-Gesichtstausch Online | WeryAI",
            "og_description": "Tauschen Sie Gesichter in Fotos sofort mit WeryAIs kostenlosem KI-Face-Swapper. Erstellen Sie lustige Memes, künstlerische Porträts (Mona Lisa) oder professionelle Headshots mit hoher Realistik. 100% privat & sicher.",
            "twitter_title": "KI-Foto-Gesichtstausch Online | WeryAI",
            "twitter_description": "Tauschen Sie Gesichter in Fotos sofort mit WeryAis kostenlosem KI-Face-Swapper. Erstellen Sie lustige Memes, künstlerische Porträts (Mona Lisa) oder professionelle Headshots mit hoher Realistik. 100% privat & sicher.",
            "page": {
                "title1": "Kostenloser KI-Foto-Face Swap",
                "title2": "Wollten Sie sich schon immer als Astronaut, Filmstar oder in einem klassischen Gemälde sehen? Laden Sie ein Basisfoto und ein Zielgesicht hoch – unsere KI blendet Gesichtszüge, Licht und Hautton nahtlos, für einen hyperrealistischen Face Swap in Sekunden.",
                "faq": [
                    {
                        "question": "Ist WeryAI Face Swap kostenlos?",
                        "answer": "Ja! Neue Nutzer erhalten bei der Registrierung kostenlose Credits, ganz ohne Kreditkarte. Außerdem können Sie durch tägliches Einchecken, das Abschließen von Aufgaben und das Einladen von Freunden weiterhin kostenlose Credits erhalten, sodass Sie den Face Swap ohne Vorauszahlung nutzen können."
                    },
                    {
                        "question": "Sind meine Daten sicher?",
                        "answer": "Absolut. Ihre Privatsphäre hat Priorität. Hochgeladene Fotos werden nur für den Tausch verwendet und nach kurzer Zeit automatisch von unseren Servern gelöscht."
                    },
                    {
                        "question": "Wie bekomme ich die besten Ergebnisse?",
                        "answer": "Für den realistischsten Tausch sollten sowohl „Basisbild“ als auch „Gesichtsbild“ klar, frontal und gut ausgeleuchtet sein. Vermeiden Sie Fotos, bei denen das Gesicht von Haaren oder Händen verdeckt ist."
                    },
                    {
                        "question": "Kann ich Gesichter in Gruppenfotos tauschen?",
                        "answer": "Aktuell konzentrieren wir uns auf höchste Präzision bei einem einzelnen Gesicht. Für Gruppenfotos bitte zuschneiden oder unsere kommende Multi-Face-Funktion nutzen."
                    },
                    {
                        "question": "Kann ich es für Memes nutzen?",
                        "answer": "Ja! Perfekt für lustige Memes. Tauschen Sie das Gesicht eines Freundes auf ein Filmplakat oder ein virales Meme-Template – sofort."
                    }
                ]
            },
            "faq": [
                {
                    "question": "Ist WeryAI Face Swap kostenlos?",
                    "answer": "Ja! Neue Nutzer erhalten kostenlose Credits bei der Registrierung ohne Kreditkarte. Weitere Credits gibt es durch tägliches Einchecken, Aufgaben und Einladungen von Freunden."
                },
                {
                    "question": "Sind meine Daten sicher?",
                    "answer": "Ja. Ihre Fotos werden nur für den Tausch genutzt und nach kurzer Zeit automatisch gelöscht."
                },
                {
                    "question": "Wie bekomme ich die besten Ergebnisse?",
                    "answer": "Achten Sie auf klare, frontale und gut beleuchtete Fotos. Vermeiden Sie verdeckte Gesichter (Haare/Brille)."
                }
            ],
            "feature_title1": "Künstlerische Meisterwerke",
            "feature_desc1": "Zeitreise: Tauschen Sie Ihr Gesicht in klassische Ölgemälde wie die Mona Lisa oder das Mädchen mit dem Perlenohrring. Erstellen Sie sofort einzigartige Vintage-Avatare.",
            "feature_title2": "Professionelle & Coole Avatare",
            "feature_desc2": "Traumjobs: Sehen Sie sich im Rennanzug, Astronauten-Outfit oder Business-Look – ohne Kostümkauf. Perfekt für auffällige Profilbilder.",
            "feature_title3": "Hyperrealistisches Blending",
            "feature_desc3": "Kein „Aufklebe“-Effekt: Anders als einfache Cut-and-Paste-Tools analysiert WeryAI Winkel, Licht und Hauttextur, damit das Ergebnis 100% natürlich wirkt – nicht fake.",
            "howto": {
                "name": "Wie man Gesichter in Fotos online tauscht",
                "step1": {
                    "name": "Basisbild hochladen",
                    "text": "Laden Sie das Foto mit dem Körper/der Szene hoch, die Sie verwenden möchten (z. B. ein Astronaut)."
                },
                "step2": {
                    "name": "Gesichtsbild hochladen",
                    "text": "Laden Sie ein Foto des Gesichts hoch, das Sie auf den Körper tauschen möchten."
                },
                "step3": {
                    "name": "Generieren",
                    "text": "Klicken Sie auf 'Erstellen'. Die KI fügt das neue Gesicht nahtlos in das Basisbild ein."
                }
            }
        }
    },
    "ru": {
        "photoFaceSwap": {
            "title": "ИИ Замена Лица на Фото - Бесплатно | WeryAI",
            "description": "Меняйте лица на фото мгновенно с бесплатным ИИ Face Swapper от WeryAI. Создавайте смешные мемы, художественные портреты (Мона Лиза) или профессиональные headshots с высокой реалистичностью. 100% приватно и безопасно.",
            "keywords": "face swap ИИ, замена лица онлайн, поменять лицо на фото, reface бесплатно, заменить лицо на изображении, deepfake фото, мемы ИИ",
            "og_title": "ИИ Замена Лица на Фото - Бесплатно | WeryAI",
            "og_description": "Меняйте лица на фото мгновенно с бесплатным ИИ Face Swapper от WeryAI. Создавайте смешные мемы, художественные портреты (Мона Лиза) или профессиональные headshots с высокой реалистичностью. 100% приватно и безопасно.",
            "twitter_title": "ИИ Замена Лица на Фото - Бесплатно | WeryAI",
            "twitter_description": "Меняйте лица на фото мгновенно с бесплатным ИИ Face Swapper от WeryAI. Создавайте смешные мемы, художественные портреты (Мона Лиза) или профессиональные headshots с высокой реалистичностью. 100% приватно и безопасно.",
            "page": {
                "title1": "Бесплатный ИИ Face Swap для Фото",
                "title2": "Хотите увидеть себя астронавтом, кинозвездой или в классической картине? Загрузите базовое фото и целевое лицо — наш ИИ бесшовно смешает черты лица, освещение и тон кожи, создавая гиперреалистичный face swap за секунды.",
                "faq": [
                    {
                        "question": "WeryAI Face Swap бесплатный?",
                        "answer": "Да! Новые пользователи получают бесплатные кредиты при регистрации без банковской карты. Вы также можете получать бесплатные кредиты за ежедневные отметки, выполнение заданий и приглашение друзей, чтобы продолжать пользоваться заменой лиц без предоплаты."
                    },
                    {
                        "question": "Мои данные в безопасности?",
                        "answer": "Абсолютно. Мы ставим приватность на первое место. Загруженные фото используются только для обмена и автоматически удаляются с серверов спустя короткое время."
                    },
                    {
                        "question": "Как получить лучший результат?",
                        "answer": "Для максимально реалистичного результата убедитесь, что и “Базовое фото”, и “Фото лица” четкие, анфас и с хорошим освещением. Избегайте кадров, где лицо закрыто волосами или руками."
                    },
                    {
                        "question": "Можно ли менять лица на групповых фото?",
                        "answer": "Сейчас мы фокусируемся на точности замены одного лица. Для групповых фото — обрежьте изображение или дождитесь нашей функции multi-face."
                    },
                    {
                        "question": "Можно ли делать мемы?",
                        "answer": "Да! Идеально для смешных мемов. Поменяйте лицо друга на киноафише или в вирусном шаблоне мемов за секунды."
                    }
                ]
            },
            "faq": [
                {
                    "question": "WeryAI Face Swap бесплатный?",
                    "answer": "Да! Новые пользователи получают бесплатные кредиты при регистрации без карты. Получайте больше кредитов через ежедневные отметки, задания и приглашение друзей."
                },
                {
                    "question": "Мои данные в безопасности?",
                    "answer": "Да. Фото используются только для замены и автоматически удаляются спустя короткое время."
                },
                {
                    "question": "Как получить лучший результат?",
                    "answer": "Убедитесь, что обе фотографии четкие, анфас и хорошо освещены. Избегайте лиц, закрытых волосами или очками."
                }
            ],
            "feature_title1": "Художественные Шедевры",
            "feature_desc1": "Путешествие во времени: Поместите свое лицо в классические картины вроде Моны Лизы или Девушки с жемчужной сережкой. Создайте уникальные винтажные аватары мгновенно.",
            "feature_title2": "Профессиональные и Стильные Аватары",
            "feature_desc2": "Работа мечты: Увидьте себя в гоночном костюме, снаряжении астронавта или деловой одежде без покупки костюма. Идеально для выделяющихся фото профиля.",
            "feature_title3": "Гиперреалистичное Смешивание",
            "feature_desc3": "Без эффекта “вставки”: В отличие от простого вырезания и вставки, WeryAI анализирует угол, освещение и текстуру кожи, чтобы лицо выглядело 100% естественно, а не фальшиво.",
            "howto": {
                "name": "Как поменять лица на фото онлайн",
                "step1": {
                    "name": "Загрузить базовое изображение",
                    "text": "Загрузите фото, содержащее тело/сцену, которую вы хотите использовать (например, космонавт)."
                },
                "step2": {
                    "name": "Загрузить изображение лица",
                    "text": "Загрузите фото лица, которое вы хотите перенести на тело."
                },
                "step3": {
                    "name": "Сгенерировать",
                    "text": "Нажмите «Создать». ИИ плавно впишет новое лицо в базовое изображение."
                }
            }
        }
    },
    "pt": {
        "photoFaceSwap": {
            "title": "Trocar Rosto em Fotos com IA Grátis | WeryAI",
            "description": "Troque rostos em fotos instantaneamente com o Face Swapper IA grátis da WeryAI. Crie memes engraçados, retratos artísticos (Mona Lisa) ou headshots profissionais com alto realismo. 100% privado e seguro.",
            "keywords": "face swap IA, troca de rosto online, mudador de rosto, reface grátis, substituir rosto na imagem, deepfake foto, criador de memes IA",
            "og_title": "Trocar Rosto em Fotos com IA Grátis | WeryAI",
            "og_description": "Troque rostos em fotos instantaneamente com o Face Swapper IA grátis da WeryAI. Crie memes engraçados, retratos artísticos (Mona Lisa) ou headshots profissionais com alto realismo. 100% privado e seguro.",
            "twitter_title": "Trocar Rosto em Fotos com IA Grátis | WeryAI",
            "twitter_description": "Troque rostos em fotos instantaneamente com o Face Swapper IA grátis da WeryAI. Crie memes engraçados, retratos artísticos (Mona Lisa) ou headshots profissionais com alto realismo. 100% privado e seguro.",
            "page": {
                "title1": "Face Swap em Foto com IA Grátis",
                "title2": "Quer se ver como astronauta, estrela de cinema ou dentro de uma pintura clássica? Envie uma foto base e um rosto alvo, e nossa IA vai mesclar traços faciais, iluminação e tons de pele para um face swap hiper-realista em segundos.",
                "faq": [
                    {
                        "question": "O Face Swap da WeryAI é gratuito?",
                        "answer": "Sim! Novos usuários recebem créditos grátis ao se cadastrar, sem cartão de crédito. Você também pode ganhar mais créditos grátis com check-in diário, conclusão de tarefas e convite de amigos, para usar o face swap sem pagar antecipadamente."
                    },
                    {
                        "question": "Meus dados estão seguros?",
                        "answer": "Com certeza. Priorizamos sua privacidade. As fotos enviadas são usadas apenas no processo de troca e são deletadas automaticamente dos nossos servidores após um curto período."
                    },
                    {
                        "question": "Como obter os melhores resultados?",
                        "answer": "Para um resultado mais realista, garanta que a “Imagem Base” e a “Imagem do Rosto” estejam nítidas, de frente e com boa iluminação. Evite fotos com o rosto coberto por cabelo ou mãos."
                    },
                    {
                        "question": "Posso trocar rostos em fotos de grupo?",
                        "answer": "No momento, nosso foco é a precisão em um único rosto. Para fotos de grupo, recorte a imagem ou aguarde nosso recurso de múltiplos rostos."
                    },
                    {
                        "question": "Posso usar para memes?",
                        "answer": "Sim! É perfeito para criar memes engraçados. Troque o rosto de um amigo em um pôster de filme ou em um template viral instantaneamente."
                    }
                ]
            },
            "faq": [
                {
                    "question": "O Face Swap da WeryAI é gratuito?",
                    "answer": "Sim! Novos usuários recebem créditos grátis ao se cadastrar sem cartão. Ganhe mais créditos com check-in diário, tarefas e convites de amigos."
                },
                {
                    "question": "Meus dados estão seguros?",
                    "answer": "Sim. As fotos são usadas apenas para a troca e são deletadas automaticamente após um curto período."
                },
                {
                    "question": "Como obter os melhores resultados?",
                    "answer": "Garanta que ambas as fotos estejam nítidas, de frente e bem iluminadas. Evite rostos cobertos por cabelo ou óculos."
                }
            ],
            "feature_title1": "Obras-primas Artísticas",
            "feature_desc1": "Viagem no tempo: Troque seu rosto em pinturas clássicas como a Mona Lisa ou A Moça com Brinco de Pérola. Crie avatares vintage únicos instantaneamente.",
            "feature_title2": "Avatares Profissionais e Estilosos",
            "feature_desc2": "Empregos dos sonhos: Veja-se com macacão de corrida, traje de astronauta ou roupa social sem comprar fantasia. Perfeito para fotos de perfil que se destacam.",
            "feature_title3": "Mistura Hiper-realista",
            "feature_desc3": "Sem efeito “colado”: Diferente de ferramentas simples de recortar e colar, a WeryAI analisa ângulo, luz e textura da pele para garantir que o rosto trocado pareça 100% natural, não falso.",
            "howto": {
                "name": "Como trocar rostos em fotos online",
                "step1": {
                    "name": "Enviar imagem base",
                    "text": "Envie a foto contendo o corpo/cena que deseja usar (por exemplo, um astronauta)."
                },
                "step2": {
                    "name": "Enviar imagem do rosto",
                    "text": "Envie uma foto do rosto que deseja trocar no corpo."
                },
                "step3": {
                    "name": "Gerar",
                    "text": "Clique em 'Criar'. A IA misturará perfeitamente o novo rosto na imagem base."
                }
            }
        }
    },
    "it": {
        "photoFaceSwap": {
            "title": "Scambio Viso Foto IA Gratis Online | WeryAI",
            "description": "Scambia volti nelle foto all'istante con il Face Swapper IA gratuito di WeryAI. Crea meme divertenti, ritratti artistici (Mona Lisa) o headshot professionali con alto realismo. 100% privato e sicuro.",
            "keywords": "face swap IA, scambio volto online, cambia volto foto, reface gratis, sostituire volto in immagine, deepfake foto, meme maker IA",
            "og_title": "Scambio Viso Foto IA Gratis Online | WeryAI",
            "og_description": "Scambia volti nelle foto all'istante con il Face Swapper IA gratuito di WeryAI. Crea meme divertenti, ritratti artistici (Mona Lisa) o headshot professionali con alto realismo. 100% privato e sicuro.",
            "twitter_title": "Scambio Viso Foto IA Gratis Online | WeryAI",
            "twitter_description": "Scambia volti nelle foto all'istante con il Face Swapper IA gratuito di WeryAI. Crea meme divertenti, ritratti artistici (Mona Lisa) o headshot professionali con alto realismo. 100% privato e sicuro.",
            "page": {
                "title1": "Face Swap Foto IA Gratis",
                "title2": "Vuoi vederti come astronauta, star del cinema o dentro un dipinto classico? Carica una foto base e un volto target: la nostra IA fonde tratti del viso, illuminazione e tonalità della pelle per un face swap iper-realistico in pochi secondi.",
                "faq": [
                    {
                        "question": "WeryAI Face Swap è gratuito?",
                        "answer": "Sì! I nuovi utenti ricevono crediti gratuiti alla registrazione senza carta di credito. Inoltre, puoi continuare a ottenere crediti gratuiti con il check-in giornaliero, il completamento delle attività e l'invito di amici, così puoi usare il face swap senza pagare in anticipo."
                    },
                    {
                        "question": "I miei dati sono al sicuro?",
                        "answer": "Assolutamente. La privacy è una priorità. Le foto caricate sono usate solo per lo scambio e vengono eliminate automaticamente dai nostri server dopo poco tempo."
                    },
                    {
                        "question": "Come ottenere i migliori risultati?",
                        "answer": "Per un risultato più realistico, assicurati che sia l'“Immagine Base” che l'“Immagine Volto” siano nitide, frontali e ben illuminate. Evita foto con il volto coperto da capelli o mani."
                    },
                    {
                        "question": "Posso scambiare volti in foto di gruppo?",
                        "answer": "Al momento ci concentriamo sulla precisione con un solo volto. Per foto di gruppo, ritaglia l'immagine o usa la prossima funzione multi-volto."
                    },
                    {
                        "question": "Posso usarlo per i meme?",
                        "answer": "Sì! È perfetto per meme divertenti. Scambia il volto di un amico su un poster di un film o su un template virale in un attimo."
                    }
                ]
            },
            "faq": [
                {
                    "question": "WeryAI Face Swap è gratuito?",
                    "answer": "Sì! I nuovi utenti ricevono crediti gratuiti alla registrazione senza carta di credito. Ottieni più crediti con il check-in giornaliero, le attività e l'invito di amici."
                },
                {
                    "question": "I miei dati sono al sicuro?",
                    "answer": "Sì. Le foto sono usate solo per lo scambio e vengono eliminate automaticamente dopo poco tempo."
                },
                {
                    "question": "Come ottenere i migliori risultati?",
                    "answer": "Assicurati che entrambe le foto siano nitide, frontali e ben illuminate. Evita volti coperti da capelli o occhiali."
                }
            ],
            "feature_title1": "Capolavori Artistici",
            "feature_desc1": "Viaggio nel tempo: Scambia il tuo volto in dipinti classici come la Mona Lisa o La ragazza con l'orecchino di perla. Crea avatar vintage unici in pochi secondi.",
            "feature_title2": "Avatar Professionali e Cool",
            "feature_desc2": "Lavori da sogno: Vediti in tuta da corsa, equipaggiamento da astronauta o abbigliamento business senza comprare costumi. Perfetto per foto profilo che spiccano.",
            "feature_title3": "Fusione Iper-realistica",
            "feature_desc3": "Niente effetto “incollato”: A differenza del semplice ritaglia-e-incolla, WeryAI analizza angolo, luce e texture della pelle per un risultato 100% naturale, non finto.",
            "howto": {
                "name": "Come scambiare i volti nelle foto online",
                "step1": {
                    "name": "Carica immagine base",
                    "text": "Carica la foto contenente il corpo/la scena che desideri utilizzare (es. un astronauta)."
                },
                "step2": {
                    "name": "Carica immagine del viso",
                    "text": "Carica una foto del viso che desideri scambiare sul corpo."
                },
                "step3": {
                    "name": "Genera",
                    "text": "Fai clic su 'Crea'. L'IA fonderà perfettamente il nuovo viso nell'immagine di base."
                }
            }
        }
    },
    "ar": {
        "photoFaceSwap": {
            "title": "تبديل الوجوه في الصور بالذكاء الاصطناعي | WeryAI",
            "description": "بدّل الوجوه في الصور فورًا باستخدام أداة Face Swap المجانية من WeryAI. أنشئ ميمات مضحكة، صورًا فنية (موناليزا)، أو صورًا احترافية واقعية للغاية. خصوصية وأمان 100%.",
            "keywords": "face swap بالذكاء الاصطناعي, تبديل الوجه عبر الإنترنت, تغيير الوجه في الصورة, reface مجاني, استبدال الوجه في الصورة, deepfake صورة, صانع ميمات بالذكاء الاصطناعي",
            "og_title": "تبديل الوجوه في الصور بالذكاء الاصطناعي | WeryAI",
            "og_description": "بدّل الوجوه في الصور فورًا باستخدام أداة Face Swap المجانية من WeryAI. أنشئ ميمات مضحكة، صورًا فنية (موناليزا)، أو صورًا احترافية واقعية للغاية. خصوصية وأمان 100%.",
            "twitter_title": "تبديل الوجوه في الصور بالذكاء الاصطناعي | WeryAI",
            "twitter_description": "بدّل الوجوه في الصور فورًا باستخدام أداة Face Swap المجانية من WeryAI. أنشئ ميمات مضحكة، صورًا فنية (موناليزا)، أو صورًا احترافية واقعية للغاية. خصوصية وأمان 100%.",
            "page": {
                "title1": "تبديل الوجه في الصور بالذكاء الاصطناعي مجانًا",
                "title2": "هل تريد أن ترى نفسك كرائد فضاء أو نجم سينما أو داخل لوحة كلاسيكية؟ ارفع صورة أساسية ووجهًا مستهدفًا، ودع ذكاءنا الاصطناعي يدمج ملامح الوجه والإضاءة ودرجة لون البشرة بسلاسة لنتيجة تبديل وجه فائقة الواقعية خلال ثوانٍ.",
                "faq": [
                    {
                        "question": "هل تبديل الوجه من WeryAI مجاني؟",
                        "answer": "نعم! يحصل المستخدمون الجدد على أرصدة مجانية عند التسجيل بدون الحاجة إلى بطاقة ائتمان. ويمكنك أيضًا الاستمرار في الحصول على أرصدة مجانية من خلال تسجيل الدخول اليومي وإكمال المهام ودعوة الأصدقاء، لتتمكن من استخدام تبديل الوجوه دون دفع مسبق."
                    },
                    {
                        "question": "هل بياناتي آمنة؟",
                        "answer": "بالتأكيد. نحن نضع الخصوصية أولاً. تُستخدم الصور التي ترفعها فقط لعملية التبديل ويتم حذفها تلقائيًا من خوادمنا بعد فترة قصيرة."
                    },
                    {
                        "question": "كيف أحصل على أفضل النتائج؟",
                        "answer": "لأفضل نتيجة واقعية، تأكد أن “الصورة الأساسية” و“صورة الوجه” واضحتان ومن الأمام وبإضاءة جيدة. تجنّب الصور التي يكون فيها الوجه مغطى بالشعر أو اليدين."
                    },
                    {
                        "question": "هل يمكنني تبديل الوجوه في صور جماعية؟",
                        "answer": "حاليًا نركز على دقة تبديل وجه واحد. للصور الجماعية، قص الصورة أو استخدم ميزة تعدد الوجوه القادمة قريبًا."
                    },
                    {
                        "question": "هل يمكنني استخدامه للميمات؟",
                        "answer": "نعم! إنه مثالي لصنع ميمات مضحكة. بدّل وجه صديقك على ملصق فيلم أو قالب ميم منتشر فورًا."
                    }
                ]
            },
            "faq": [
                {
                    "question": "هل تبديل الوجه من WeryAI مجاني؟",
                    "answer": "نعم! يحصل المستخدمون الجدد على أرصدة مجانية عند التسجيل بدون بطاقة ائتمان. احصل على المزيد عبر تسجيل الدخول اليومي والمهام ودعوة الأصدقاء."
                },
                {
                    "question": "هل بياناتي آمنة؟",
                    "answer": "نعم. تُستخدم الصور فقط للتبديل ويتم حذفها تلقائيًا بعد فترة قصيرة."
                },
                {
                    "question": "كيف أحصل على أفضل النتائج؟",
                    "answer": "تأكد أن الصورتين واضحتان ومن الأمام وبإضاءة جيدة. تجنّب الوجوه المغطاة بالشعر أو النظارات."
                }
            ],
            "feature_title1": "روائع فنية",
            "feature_desc1": "سفر عبر الزمن: بدّل وجهك داخل لوحات كلاسيكية مثل موناليزا أو الفتاة ذات القرط اللؤلؤي. أنشئ صورًا رمزية قديمة وفريدة فورًا.",
            "feature_title2": "صور رمزية احترافية وجذابة",
            "feature_desc2": "وظائف الأحلام: شاهد نفسك ببدلة سباق أو معدات رائد فضاء أو ملابس رسمية دون شراء الزي. مثالي لصور ملف شخصي لافتة.",
            "feature_title3": "دمج فائق الواقعية",
            "feature_desc3": "بدون تأثير “القص واللصق”: على عكس الأدوات البسيطة، يحلل WeryAI الزاوية والإضاءة وملمس البشرة ليبدو الوجه المستبدل طبيعيًا 100% وليس مزيفًا.",
            "howto": {
                "name": "كيفية تبديل الوجوه في الصور عبر الإنترنت",
                "step1": {
                    "name": "تحميل الصورة الأساسية",
                    "text": "قم بتحميل الصورة التي تحتوي على الجسم/المشهد الذي تريد استخدامه (مثل رائد فضاء)."
                },
                "step2": {
                    "name": "تحميل صورة الوجه",
                    "text": "قم بتحميل صورة للوجه الذي تريد تبديله على الجسم."
                },
                "step3": {
                    "name": "إنشاء",
                    "text": "انقر على 'إنشاء'. سيقوم الذكاء الاصطناعي بدمج الوجه الجديد بسلاسة في الصورة الأساسية."
                }
            }
        }
    },
    "tw": {
        "photoFaceSwap": {
            "title": "免費 AI 照片換臉 - 線上人臉替換 | WeryAI",
            "description": "想做趣味迷因、角色扮演照或專業頭像？上傳底圖與人臉照，WeryAI 就能自然融合五官、光線與膚色，快速完成高擬真照片換臉。",
            "keywords": "AI 換臉, 在線換臉, 照片換臉器, 免費換臉, 替換圖片中的臉部, Deepfake 照片, 迷因製作 AI",
            "howto": {
                "name": "如何使用",
                "step1": {
                    "name": "上傳底圖",
                    "text": "選擇一张您想要被替換人臉的圖片（例如：電影海报、名人合影等）。"
                },
                "step2": {
                    "name": "上傳人臉圖",
                    "text": "再上傳一张包含您想使用的人臉的清晰照片。"
                },
                "step3": {
                    "name": "一键產生並下載",
                    "text": "點擊\"產生\"，AI 将在几秒内完成換臉。預覽满意後，即可下載你的創意作品！"
                }
            },
            "og_title": "免費 AI 照片換臉 - 線上人臉替換 | WeryAI",
            "og_description": "想做趣味迷因、角色扮演照或專業頭像？上傳底圖與人臉照，WeryAI 就能自然融合五官、光線與膚色，快速完成高擬真照片換臉。",
            "twitter_title": "免費 AI 照片換臉 - 線上人臉替換 | WeryAI",
            "twitter_description": "想做趣味迷因、角色扮演照或專業頭像？上傳底圖與人臉照，WeryAI 就能自然融合五官、光線與膚色，快速完成高擬真照片換臉。",
            "app_name": "WeryAI AI 照片換臉",
            "app_desc": "想看看自己穿上宇航服的样子吗？或者和朋友来一場跨越時空的合影？WeryAI 圖片換臉工具，讓你轻松将任意人臉融合到任何圖片中，效果逼真，毫無违和感。",
            "page": {
                "title1": "AI 圖片換臉，一键化身万千角色",
                "title2": "想看看自己穿上宇航服的样子吗？或者和朋友来一場跨越時空的合影？WeryAI 圖片換臉工具，讓你轻松将任意人臉融合到任何圖片中，效果逼真，毫無违和感。",
                "faq": [
                    {
                        "question": "什麼是 AI 圖片換臉？",
                        "answer": "它是一种利用深度学习技術，将一张圖片中的人臉（A）精准地替換到另一张圖片的人臉（B）上，同時保留 B 圖的表情、光照和風格，產生一张全新合成圖的工具。"
                    },
                    {
                        "question": "這個工具是如何工作的？",
                        "answer": "AI 會首先精准定位兩张圖片中的人臉關键特征点。然後，它會将源人臉的臉部特征\"移植\"到目标人臉上，並通过復雜的融合算法，調整光影、肤色等細節，使其看起来天衣無缝。"
                    },
                    {
                        "question": "想要效果好，上傳什麼样的照片最佳？",
                        "answer": "為了獲得最佳效果，建议您上傳清晰、正臉且光線良好的照片。如果兩张照片的人臉角度和光照方向越接近，最终合成的效果會越逼真。"
                    },
                    {
                        "question": "可以在一张合照裡只换其中一個人的臉吗？",
                        "answer": "可以。我們的 AI 會智慧識別圖中的多個人臉。在未来的版本中，您将可以選擇具體替換哪一张臉。目前，系统會優先處理最主要的人臉。"
                    },
                    {
                        "question": "這個換臉工具是免費的吗？",
                        "answer": "是的！WeryAI 為所有用戶提供免費试用次數，讓您可以零成本體驗 AI 換臉带来的樂趣和强大功能。"
                    }
                ]
            },
            "faq": [
                {
                    "question": "什麼是 AI 圖片換臉？",
                    "answer": "它是一种利用深度学习技術，将一张圖片中的人臉（A）精准地替換到另一张圖片的人臉（B）上，同時保留 B 圖的表情、光照和風格，產生一张全新合成圖的工具。"
                },
                {
                    "question": "這個工具是如何工作的？",
                    "answer": "AI 會首先精准定位兩张圖片中的人臉關键特征点。然後，它會将源人臉的臉部特征\"移植\"到目标人臉上，並通过復雜的融合算法，調整光影、肤色等細節，使其看起来天衣無缝。"
                },
                {
                    "question": "想要效果好，上傳什麼样的照片最佳？",
                    "answer": "為了獲得最佳效果，建议您上傳清晰、正臉且光線良好的照片。如果兩张照片的人臉角度和光照方向越接近，最终合成的效果會越逼真。"
                },
                {
                    "question": "可以在一张合照裡只换其中一個人的臉吗？",
                    "answer": "可以。我們的 AI 會智慧識別圖中的多個人臉。在未来的版本中，您将可以選擇具體替換哪一张臉。目前，系统會優先處理最主要的人臉。"
                },
                {
                    "question": "這個換臉工具是免費的吗？",
                    "answer": "是的！WeryAI 為所有用戶提供免費试用次數，讓您可以零成本體驗 AI 換臉带来的樂趣和强大功能。"
                }
            ],
            "feature_title1": "AI 驱动，效果逼真",
            "feature_desc1": "我們的 AI 算法能智慧分析光照、角度、肤色和表情，将新的人臉完美融合到目标圖片中。从光影匹配到細節處理，效果自然到讓肉眼难辨真伪。",
            "feature_title2": "操作至简，秒速出圖",
            "feature_desc2": "告別復雜的 P圖軟體！你只需要上傳一张底圖和一张人臉圖，剩下的全部交给 AI。無需任何编辑技巧，點擊一下，創意大作秒速產生。",
            "feature_title3": "释放創意，欢樂無限",
            "feature_desc3": "制作搞笑的 Meme 表情包、将朋友\"穿越\"到历史名畫、或者與你的偶像来一张\"亲密合影\"。無論是自娱自樂还是社交分享，都能為你带来無穷樂趣。",
            "feature_title4": "隱私安全",
            "feature_desc4": "你的上傳內容會以安全方式處理，僅用於當前任務，不會被濫用。"
        }
    },
    "pl": {
        "photoFaceSwap": {
            "title": "Darmowa Zamiana Twarzy AI w Zdjęciach | WeryAI",
            "description": "Zamieniaj twarze na zdjęciach błyskawicznie z AI. Twórz śmieszne memy, artystyczne portrety lub profesjonalne awatary. Realistyczne efekty w sekundy. Darmowe kredyty na start!",
            "keywords": "zamiana twarzy AI, podmiana twarzy online, face swap zdjęcia, zmiana twarzy AI, generator memów AI, reface za darmo, deepfake zdjęcie",
            "og_title": "Darmowa Zamiana Twarzy AI w Zdjęciach | WeryAI",
            "og_description": "Zamieniaj twarze na zdjęciach błyskawicznie z AI. Twórz śmieszne memy, artystyczne portrety lub profesjonalne awatary. Realistyczne efekty w sekundy. Darmowe kredyty na start!",
            "twitter_title": "Darmowa Zamiana Twarzy AI w Zdjęciach | WeryAI",
            "twitter_description": "Zamieniaj twarze na zdjęciach błyskawicznie z AI. Twórz śmieszne memy, artystyczne portrety lub profesjonalne awatary. Realistyczne efekty w sekundy. Darmowe kredyty na start!",
            "page": {
                "title1": "Darmowa Zamiana Twarzy AI w Zdjęciach",
                "title2": "Chcesz zobaczyć siebie jako astronautę, gwiazdę filmową lub na klasycznym obrazie? Prześlij zdjęcie bazowe i docelową twarz, a nasza AI płynnie połączy cechy twarzy, oświetlenie i odcień skóry, tworząc hiperrealistyczną podmianę w kilka sekund.",
                "faq": [
                    {
                        "question": "Czy mogę używać WeryAI Photo Face Swap za darmo?",
                        "answer": "Tak! Nowi użytkownicy otrzymują darmowe kredyty przy rejestracji — bez karty kredytowej. Możesz też zdobywać kolejne darmowe kredyty poprzez codzienny check-in, wykonywanie zadań i zapraszanie znajomych, więc możesz korzystać ze zamiany twarzy bez płacenia z góry."
                    },
                    {
                        "question": "Czy moje dane są bezpieczne?",
                        "answer": "Oczywiście. Prywatność jest dla nas priorytetem. Przesłane zdjęcia są używane wyłącznie do zamiany twarzy i automatycznie usuwane z naszych serwerów po krótkim czasie."
                    },
                    {
                        "question": "Jak uzyskać najlepsze rezultaty?",
                        "answer": "Aby uzyskać najbardziej realistyczny efekt, upewnij się, że zarówno zdjęcie bazowe, jak i zdjęcie twarzy są wyraźne, z przodu i dobrze oświetlone. Unikaj zdjęć, na których twarz jest zasłonięta włosami lub rękami."
                    },
                    {
                        "question": "Czy mogę zamieniać twarze na zdjęciach grupowych?",
                        "answer": "Obecnie nasze narzędzie skupia się na precyzyjnej zamianie jednej twarzy. W przypadku zdjęć grupowych przytnij obraz lub skorzystaj z naszej nadchodzącej funkcji wielu twarzy."
                    },
                    {
                        "question": "Czy mogę tego użyć do memów?",
                        "answer": "Tak! Idealnie nadaje się do tworzenia śmiesznych memów. Podmień twarz znajomego na plakat filmowy lub wiralowy szablon mema w mgnieniu oka. Aby zamieniać twarze w filmach, sprawdź nasze narzędzie <a href=\"/video-face-swap\">Video Face Swap</a>."
                    }
                ]
            },
            "faq": [
                {
                    "question": "Czy mogę używać WeryAI Photo Face Swap za darmo?",
                    "answer": "Tak! Nowi użytkownicy otrzymują darmowe kredyty przy rejestracji — bez karty kredytowej. Możesz też zdobywać kolejne darmowe kredyty poprzez codzienny check-in, wykonywanie zadań i zapraszanie znajomych."
                },
                {
                    "question": "Czy moje dane są bezpieczne?",
                    "answer": "Oczywiście. Przesłane zdjęcia są używane wyłącznie do zamiany i automatycznie usuwane z serwerów po krótkim czasie."
                },
                {
                    "question": "Jak uzyskać najlepsze rezultaty?",
                    "answer": "Upewnij się, że oba zdjęcia są wyraźne, z przodu i dobrze oświetlone. Unikaj twarzy zasłoniętych włosami lub okularami."
                }
            ],
            "feature_title1": "Artystyczne Arcydzieła",
            "feature_desc1": "Podróż w czasie: Podmień swoją twarz w klasycznych obrazach olejnych jak Mona Lisa lub Dziewczyna z perłą. Twórz unikalne vintage awatary natychmiast.",
            "feature_title2": "Profesjonalne i Stylowe Awatary",
            "feature_desc2": "Praca marzeń: Zobacz siebie w kombinezonie wyścigowym, stroju astronauty lub garniturze biznesowym bez kupowania kostiumu. Idealne na wyróżniające się zdjęcia profilowe.",
            "feature_title3": "Hiperrealistyczne Łączenie",
            "feature_desc3": "Bez efektu wklejania: W przeciwieństwie do prostych narzędzi kopiuj-wklej, WeryAI analizuje kąt, oświetlenie i teksturę skóry, aby zamieniona twarz wyglądała w 100% naturalnie.",
            "howto": {
                "name": "Jak zamieniać twarze na zdjęciach online",
                "step1": {
                    "name": "Prześlij zdjęcie bazowe",
                    "text": "Prześlij zdjęcie z ciałem/sceną, której chcesz użyć (np. astronauta)."
                },
                "step2": {
                    "name": "Prześlij zdjęcie twarzy",
                    "text": "Prześlij zdjęcie twarzy, którą chcesz zamienić na ciele."
                },
                "step3": {
                    "name": "Generuj",
                    "text": "Kliknij Utwórz. AI płynnie wtopi nową twarz w obraz bazowy."
                }
            }
        }
    },
    "th": {
        "photoFaceSwap": {
            "title": "สลับใบหน้าในรูปภาพด้วย AI ฟรี | WeryAI",
            "description": "สลับใบหน้าในภาพถ่ายทันทีด้วย AI สร้างมีมตลก ภาพเหมือนศิลปะ หรืออวาตาร์มืออาชีพ ผลลัพธ์สมจริงในไม่กี่วินาที เครดิตฟรีเมื่อเริ่มใช้งาน!",
            "keywords": "สลับใบหน้า AI, สลับหน้าออนไลน์, ตัวเปลี่ยนใบหน้าภาพถ่าย, reface ฟรี, เปลี่ยนหน้าในรูป, ดีปเฟคภาพถ่าย, สร้างมีม AI",
            "og_title": "สลับใบหน้าในรูปภาพด้วย AI ฟรี | WeryAI",
            "og_description": "สลับใบหน้าในภาพถ่ายทันทีด้วย AI สร้างมีมตลก ภาพเหมือนศิลปะ หรืออวาตาร์มืออาชีพ ผลลัพธ์สมจริงในไม่กี่วินาที เครดิตฟรีเมื่อเริ่มใช้งาน!",
            "twitter_title": "สลับใบหน้าในรูปภาพด้วย AI ฟรี | WeryAI",
            "twitter_description": "สลับใบหน้าในภาพถ่ายทันทีด้วย AI สร้างมีมตลก ภาพเหมือนศิลปะ หรืออวาตาร์มืออาชีพ ผลลัพธ์สมจริงในไม่กี่วินาที เครดิตฟรีเมื่อเริ่มใช้งาน!",
            "page": {
                "title1": "สลับใบหน้าภาพถ่าย AI ฟรี",
                "title2": "อยากเห็นตัวเองเป็นนักบินอวกาศ ดาราหนัง หรือในภาพวาดคลาสสิก? อัปโหลดภาพพื้นฐานและใบหน้าเป้าหมาย แล้ว AI ของเราจะผสานลักษณะใบหน้า แสง และโทนสีผิวอย่างลื่นไหลเพื่อสลับใบหน้าแบบสมจริงมากในไม่กี่วินาที",
                "faq": [
                    {
                        "question": "สามารถใช้ WeryAI Photo Face Swap ฟรีได้ไหม?",
                        "answer": "ได้! ผู้ใช้ใหม่จะได้รับเครดิตฟรีเมื่อสมัครสมาชิก ไม่ต้องใช้บัตรเครดิต นอกจากนี้ยังสามารถรับเครดิตฟรีเพิ่มได้จากการเช็กอินรายวัน ทำภารกิจ และเชิญเพื่อน จึงใช้งาน Photo Face Swap ได้ต่อเนื่องโดยไม่ต้องจ่ายล่วงหน้า"
                    },
                    {
                        "question": "ข้อมูลของฉันปลอดภัยไหม?",
                        "answer": "ปลอดภัยอย่างแน่นอน เราให้ความสำคัญกับความเป็นส่วนตัวของคุณ รูปภาพที่อัปโหลดจะถูกใช้เฉพาะในกระบวนการสลับใบหน้าเท่านั้น และจะถูกลบจากเซิร์ฟเวอร์โดยอัตโนมัติหลังจากช่วงเวลาสั้นๆ"
                    },
                    {
                        "question": "จะได้ผลลัพธ์ที่ดีที่สุดได้อย่างไร?",
                        "answer": "เพื่อให้ได้การสลับที่สมจริงที่สุด ตรวจสอบให้แน่ใจว่าทั้งรูปพื้นฐานและรูปใบหน้ามีความชัดเจน หันหน้าตรง และมีแสงสว่างเพียงพอ หลีกเลี่ยงรูปที่ใบหน้าถูกบังด้วยผมหรือมือ"
                    },
                    {
                        "question": "สามารถสลับใบหน้าในรูปกลุ่มได้ไหม?",
                        "answer": "ขณะนี้เครื่องมือของเรามุ่งเน้นที่ความแม่นยำในการสลับใบหน้าเดียว สำหรับรูปกลุ่ม ให้ครอปรูปก่อน หรือรอฟีเจอร์หลายใบหน้าที่กำลังจะเปิดตัว"
                    },
                    {
                        "question": "สามารถใช้ทำมีมได้ไหม?",
                        "answer": "ได้! เหมาะสำหรับสร้างมีมตลก สลับใบหน้าเพื่อนลงบนโปสเตอร์หนังหรือเทมเพลตมีมไวรัลได้ทันที สำหรับการสลับใบหน้าในวิดีโอ ลองดู <a href=\"/video-face-swap\">Video Face Swap</a>"
                    }
                ]
            },
            "faq": [
                {
                    "question": "สามารถใช้ WeryAI Photo Face Swap ฟรีได้ไหม?",
                    "answer": "ได้! ผู้ใช้ใหม่จะได้รับเครดิตฟรีเมื่อสมัครสมาชิก ไม่ต้องใช้บัตรเครดิต นอกจากนี้ยังรับเครดิตฟรีเพิ่มได้จากการเช็กอินรายวัน ทำภารกิจ และเชิญเพื่อน"
                },
                {
                    "question": "ข้อมูลของฉันปลอดภัยไหม?",
                    "answer": "ปลอดภัย รูปภาพที่อัปโหลดจะถูกใช้เฉพาะในกระบวนการสลับใบหน้า และจะถูกลบจากเซิร์ฟเวอร์โดยอัตโนมัติ"
                },
                {
                    "question": "จะได้ผลลัพธ์ที่ดีที่สุดได้อย่างไร?",
                    "answer": "ตรวจสอบให้แน่ใจว่ารูปทั้งสองชัดเจน หันหน้าตรง และมีแสงเพียงพอ หลีกเลี่ยงใบหน้าที่ถูกบังด้วยผมหรือแว่น"
                }
            ],
            "feature_title1": "ผลงานศิลปะชั้นครู",
            "feature_desc1": "ย้อนเวลา: สลับใบหน้าของคุณเข้าไปในภาพวาดสีน้ำมันคลาสสิกอย่าง Mona Lisa หรือ Girl with a Pearl Earring สร้างอวาตาร์วินเทจที่ไม่เหมือนใครทันที",
            "feature_title2": "อวาตาร์มืออาชีพและเท่",
            "feature_desc2": "งานในฝัน: ดูตัวเองในชุดแข่งรถ ชุดนักบินอวกาศ หรือชุดสูทธุรกิจโดยไม่ต้องซื้อเครื่องแต่งกาย เหมาะสำหรับสร้างรูปโปรไฟล์ที่โดดเด่น",
            "feature_title3": "การผสานที่สมจริงมาก",
            "feature_desc3": "ไม่มีเอฟเฟกต์วาง: ไม่เหมือนเครื่องมือตัดแปะธรรมดา WeryAI วิเคราะห์มุม แสง และพื้นผิวผิวเพื่อให้ใบหน้าที่สลับดูเป็นธรรมชาติ 100% ไม่ปลอม",
            "howto": {
                "name": "วิธีสลับใบหน้าในรูปภาพออนไลน์",
                "step1": {
                    "name": "อัปโหลดรูปภาพหลัก",
                    "text": "อัปโหลดรูปภาพที่มีร่างกาย/ฉากที่คุณต้องการใช้ (เช่น นักบินอวกาศ)"
                },
                "step2": {
                    "name": "อัปโหลดรูปภาพใบหน้า",
                    "text": "อัปโหลดรูปภาพใบหน้าที่คุณต้องการสลับลงบนร่างกาย"
                },
                "step3": {
                    "name": "สร้าง",
                    "text": "คลิก สร้าง AI จะผสมผสานใบหน้าใหม่เข้ากับรูปภาพหลักอย่างแนบเนียน"
                }
            }
        }
    },
    "da": {
        "photoFaceSwap": {
            "title": "Gratis AI Ansigtsbytte i Fotos Online | WeryAI",
            "description": "Byt ansigter på fotos øjeblikkeligt med AI. Skab sjove memes, kunstneriske portrætter eller professionelle avatarer. Realistiske resultater på sekunder. Gratis credits!",
            "keywords": "ai ansigtsbytte, ansigtsbytte online, foto ansigtsskifter, reface gratis, erstat ansigt i billede, deepfake foto, meme maker ai",
            "og_title": "Gratis AI Ansigtsbytte i Fotos Online | WeryAI",
            "og_description": "Byt ansigter på fotos øjeblikkeligt med AI. Skab sjove memes, kunstneriske portrætter eller professionelle avatarer. Realistiske resultater på sekunder. Gratis credits!",
            "twitter_title": "Gratis AI Ansigtsbytte i Fotos Online | WeryAI",
            "twitter_description": "Byt ansigter på fotos øjeblikkeligt med AI. Skab sjove memes, kunstneriske portrætter eller professionelle avatarer. Realistiske resultater på sekunder. Gratis credits!",
            "page": {
                "title1": "Gratis AI Foto Ansigtsbytte",
                "title2": "Vil du se dig selv som astronaut, filmstjerne eller i et klassisk maleri? Upload et basisbillede og et målansigt, og lad vores AI blande ansigtstræk, lys og hudtoner sømløst for et hyperrealistisk ansigtsbytte på få sekunder.",
                "faq": [
                    {
                        "question": "Kan jeg bruge WeryAI Photo Face Swap gratis?",
                        "answer": "Ja! Nye brugere får gratis credits ved tilmelding uden kreditkort. Du kan også fortsætte med at få gratis credits via dagligt check-in, gennemførte opgaver og invitation af venner, så du kan blive ved med at bruge Photo Face Swap uden at betale på forhånd."
                    },
                    {
                        "question": "Er mine data sikre?",
                        "answer": "Absolut. Vi prioriterer dit privatliv. De fotos, du uploader, bruges udelukkende til ansigtsbytte-processen og slettes automatisk fra vores servere efter kort tid."
                    },
                    {
                        "question": "Hvordan får jeg de bedste resultater?",
                        "answer": "For det mest realistiske bytte skal du sørge for, at både basisbilledet og ansigtsbilledet er skarpe, forfra og med god belysning. Undgå fotos, hvor ansigtet er dækket af hår eller hænder."
                    },
                    {
                        "question": "Kan jeg bytte ansigter på gruppebilleder?",
                        "answer": "I øjeblikket fokuserer vores værktøj på præcision ved enkelt-ansigtsbytte. For gruppebilleder kan du beskære billedet eller bruge vores kommende multi-ansigt-funktion."
                    },
                    {
                        "question": "Kan jeg bruge det til memes?",
                        "answer": "Ja! Det er perfekt til at lave sjove memes. Byt dit vens ansigt på en filmplakat eller en viral meme-skabelon øjeblikkeligt. Til videoansigtsbytte kan du prøve vores <a href=\"/video-face-swap\">Video Face Swap</a>-værktøj."
                    }
                ]
            },
            "faq": [
                {
                    "question": "Kan jeg bruge WeryAI Photo Face Swap gratis?",
                    "answer": "Ja! Nye brugere får gratis credits ved tilmelding uden kreditkort. Du kan også få gratis credits via dagligt check-in, opgaver og invitation af venner."
                },
                {
                    "question": "Er mine data sikre?",
                    "answer": "Ja. De uploadede fotos bruges kun til ansigtsbytte og slettes automatisk fra serverne efter kort tid."
                },
                {
                    "question": "Hvordan får jeg de bedste resultater?",
                    "answer": "Sørg for, at begge fotos er skarpe, forfra og med god belysning. Undgå ansigter dækket af hår eller briller."
                }
            ],
            "feature_title1": "Kunstneriske Mesterværker",
            "feature_desc1": "Tidsrejse: Byt dit ansigt ind i klassiske oliemalerier som Mona Lisa eller Pige med perleørering. Skab unikke vintage-avatarer øjeblikkeligt.",
            "feature_title2": "Professionelle og Fede Avatarer",
            "feature_desc2": "Drømmejob: Se dig selv i racerdragt, astronautudstyr eller forretningsattire uden at købe kostumerne. Perfekt til iøjnefaldende profilbilleder.",
            "feature_title3": "Hyperrealistisk Blending",
            "feature_desc3": "Ingen indsæt-effekt: I modsætning til simple klip-og-indsæt-værktøjer analyserer WeryAI vinkel, lys og hudtekstur for at sikre, at det byttede ansigt ser 100% naturligt ud.",
            "howto": {
                "name": "Sådan bytter du ansigter på fotos online",
                "step1": {
                    "name": "Upload basisbillede",
                    "text": "Upload billedet med den krop/scene, du vil bruge (f.eks. en astronaut)."
                },
                "step2": {
                    "name": "Upload ansigtsbillede",
                    "text": "Upload et foto af det ansigt, du vil bytte over på kroppen."
                },
                "step3": {
                    "name": "Generer",
                    "text": "Klik Opret. AI'en blander det nye ansigt sømløst ind i basisbilledet."
                }
            }
        }
    },
    "no": {
        "photoFaceSwap": {
            "title": "Gratis AI Ansiktsbytte i Bilder Online | WeryAI",
            "description": "Bytt ansikter i bilder umiddelbart med AI. Lag morsomme memer, kunstneriske portretter eller profesjonelle avatarer. Realistiske resultater på sekunder. Gratis kreditter!",
            "keywords": "ai ansiktsbytte, ansiktsbytte online, foto ansiktsveksler, reface gratis, erstatt ansikt i bilde, deepfake foto, meme maker ai",
            "og_title": "Gratis AI Ansiktsbytte i Bilder Online | WeryAI",
            "og_description": "Bytt ansikter i bilder umiddelbart med AI. Lag morsomme memer, kunstneriske portretter eller profesjonelle avatarer. Realistiske resultater på sekunder. Gratis kreditter!",
            "twitter_title": "Gratis AI Ansiktsbytte i Bilder Online | WeryAI",
            "twitter_description": "Bytt ansikter i bilder umiddelbart med AI. Lag morsomme memer, kunstneriske portretter eller profesjonelle avatarer. Realistiske resultater på sekunder. Gratis kreditter!",
            "page": {
                "title1": "Gratis AI Foto Ansiktsbytte",
                "title2": "Vil du se deg selv som astronaut, filmstjerne eller i et klassisk maleri? Last opp et basisbilde og et målansikt, og la vår AI blande ansiktstrekk, lys og hudtoner sømløst for et hyperrealistisk ansiktsbytte på få sekunder.",
                "faq": [
                    {
                        "question": "Kan jeg bruke WeryAI Photo Face Swap gratis?",
                        "answer": "Ja! Nye brukere får gratis kreditter ved registrering uten kredittkort. Du kan også fortsette å få gratis kreditter gjennom daglig innsjekking, fullførte oppgaver og invitasjon av venner, slik at du kan fortsette å bruke Photo Face Swap uten å betale på forhånd."
                    },
                    {
                        "question": "Er dataene mine trygge?",
                        "answer": "Absolutt. Vi prioriterer personvernet ditt. Bildene du laster opp brukes kun til ansiktsbytteprosessen og slettes automatisk fra serverne våre etter kort tid."
                    },
                    {
                        "question": "Hvordan får jeg best mulig resultat?",
                        "answer": "For det mest realistiske byttet, sørg for at både basisbildet og ansiktsbildet er skarpe, forfra og med god belysning. Unngå bilder der ansiktet er dekket av hår eller hender."
                    },
                    {
                        "question": "Kan jeg bytte ansikter i gruppebilder?",
                        "answer": "For øyeblikket fokuserer verktøyet vårt på presisjon ved enkelt-ansiktsbytte. For gruppebilder kan du beskjære bildet eller bruke vår kommende flerfunksjon for flere ansikter."
                    },
                    {
                        "question": "Kan jeg bruke det til memer?",
                        "answer": "Ja! Det er perfekt for å lage morsomme memer. Bytt en venns ansikt på en filmplakat eller en viral meme-mal umiddelbart. For videoansiktsbytte kan du prøve vår <a href=\"/video-face-swap\">Video Face Swap</a>."
                    }
                ]
            },
            "faq": [
                {
                    "question": "Kan jeg bruke WeryAI Photo Face Swap gratis?",
                    "answer": "Ja! Nye brukere får gratis kreditter ved registrering uten kredittkort. Du kan også få gratis kreditter gjennom daglig innsjekking, oppgaver og invitasjon av venner."
                },
                {
                    "question": "Er dataene mine trygge?",
                    "answer": "Ja. Opplastede bilder brukes kun til ansiktsbyttet og slettes automatisk etter kort tid."
                },
                {
                    "question": "Hvordan får jeg best mulig resultat?",
                    "answer": "Sørg for at begge bildene er skarpe, forfra og med god belysning. Unngå ansikter dekket av hår eller briller."
                }
            ],
            "feature_title1": "Kunstneriske Mesterverk",
            "feature_desc1": "Tidsreise: Bytt ansiktet ditt inn i klassiske oljemalerier som Mona Lisa eller Piken med perleøredobben. Lag unike vintage-avatarer umiddelbart.",
            "feature_title2": "Profesjonelle og Kule Avatarer",
            "feature_desc2": "Drømmejobb: Se deg selv i racerdrakt, astronautdrakt eller forretningsantrekk uten å kjøpe kostymene. Perfekt for iøynefallende profilbilder.",
            "feature_title3": "Hyperrealistisk Blending",
            "feature_desc3": "Ingen lim-inn-effekt: I motsetning til enkle klipp-og-lim-verktøy analyserer WeryAI vinkel, lys og hudtekstur for å sikre at det byttede ansiktet ser 100% naturlig ut.",
            "howto": {
                "name": "Hvordan bytte ansikter i bilder online",
                "step1": {
                    "name": "Last opp basisbilde",
                    "text": "Last opp bildet med kroppen/scenen du vil bruke (f.eks. en astronaut)."
                },
                "step2": {
                    "name": "Last opp ansiktsbilde",
                    "text": "Last opp et bilde av ansiktet du vil bytte over på kroppen."
                },
                "step3": {
                    "name": "Generer",
                    "text": "Klikk Opprett. AI-en blander det nye ansiktet sømløst inn i basisbildet."
                }
            }
        }
    },
    "nl": {
        "photoFaceSwap": {
            "title": "Gratis AI Gezichtswissel in Foto's Online | WeryAI",
            "description": "Verwissel gezichten in foto's direct met AI. Maak grappige memes, artistieke portretten of professionele avatars. Realistische resultaten in seconden. Gratis credits!",
            "keywords": "ai gezichtswissel, gezichtswissel online, foto gezichtswisselaar, reface gratis, gezicht vervangen in afbeelding, deepfake foto, meme maker ai",
            "og_title": "Gratis AI Gezichtswissel in Foto's Online | WeryAI",
            "og_description": "Verwissel gezichten in foto's direct met AI. Maak grappige memes, artistieke portretten of professionele avatars. Realistische resultaten in seconden. Gratis credits!",
            "twitter_title": "Gratis AI Gezichtswissel in Foto's Online | WeryAI",
            "twitter_description": "Verwissel gezichten in foto's direct met AI. Maak grappige memes, artistieke portretten of professionele avatars. Realistische resultaten in seconden. Gratis credits!",
            "page": {
                "title1": "Gratis AI Foto Gezichtswissel",
                "title2": "Wil je jezelf zien als astronaut, filmster of in een klassiek schilderij? Upload een basisfoto en een doelgezicht, en laat onze AI gezichtskenmerken, licht en huidtinten naadloos mengen voor een hyperrealistische gezichtswissel in seconden.",
                "faq": [
                    {
                        "question": "Kan ik WeryAI Photo Face Swap gratis gebruiken?",
                        "answer": "Ja! Nieuwe gebruikers krijgen gratis credits bij registratie zonder creditcard. Je kunt ook gratis credits blijven verdienen via dagelijkse check-ins, het voltooien van taken en het uitnodigen van vrienden, zodat je Photo Face Swap kunt blijven gebruiken zonder vooraf te betalen."
                    },
                    {
                        "question": "Zijn mijn gegevens veilig?",
                        "answer": "Absoluut. We geven prioriteit aan je privacy. De foto's die je uploadt worden uitsluitend gebruikt voor het wisselproces en worden automatisch van onze servers verwijderd na korte tijd."
                    },
                    {
                        "question": "Hoe krijg ik de beste resultaten?",
                        "answer": "Voor de meest realistische wissel, zorg dat zowel de basisfoto als de gezichtsfoto scherp zijn, van voren en goed belicht. Vermijd foto's waarop het gezicht bedekt is door haar of handen."
                    },
                    {
                        "question": "Kan ik gezichten verwisselen in groepsfoto's?",
                        "answer": "Momenteel richt onze tool zich op precisie bij het wisselen van één gezicht. Voor groepsfoto's kun je de afbeelding bijsnijden of onze aankomende multi-gezichtsfunctie gebruiken."
                    },
                    {
                        "question": "Kan ik het gebruiken voor memes?",
                        "answer": "Ja! Het is perfect voor het maken van grappige memes. Wissel het gezicht van een vriend op een filmposter of een virale meme-template direct. Voor video-gezichtswissels kun je onze <a href=\"/video-face-swap\">Video Face Swap</a>-tool proberen."
                    }
                ]
            },
            "faq": [
                {
                    "question": "Kan ik WeryAI Photo Face Swap gratis gebruiken?",
                    "answer": "Ja! Nieuwe gebruikers krijgen gratis credits bij registratie zonder creditcard. Verdien meer gratis credits via dagelijkse check-ins, taken en het uitnodigen van vrienden."
                },
                {
                    "question": "Zijn mijn gegevens veilig?",
                    "answer": "Ja. Geüploade foto's worden alleen voor de wissel gebruikt en automatisch van servers verwijderd na korte tijd."
                },
                {
                    "question": "Hoe krijg ik de beste resultaten?",
                    "answer": "Zorg dat beide foto's scherp, van voren en goed belicht zijn. Vermijd gezichten bedekt door haar of brillen."
                }
            ],
            "feature_title1": "Artistieke Meesterwerken",
            "feature_desc1": "Tijdreizen: Wissel je gezicht in klassieke olieverfschilderijen zoals de Mona Lisa of Meisje met de parel. Maak direct unieke vintage-avatars.",
            "feature_title2": "Professionele en Coole Avatars",
            "feature_desc2": "Droombanen: Zie jezelf in een racepak, astronautenuitrusting of zakelijke kleding zonder de kostuums te kopen. Perfect voor opvallende profielfotos.",
            "feature_title3": "Hyperrealistische Blending",
            "feature_desc3": "Geen plak-effect: In tegenstelling tot simpele knip-en-plak-tools analyseert WeryAI de hoek, belichting en huidtextuur om ervoor te zorgen dat het gewisselde gezicht 100% natuurlijk oogt.",
            "howto": {
                "name": "Hoe gezichten in foto's online te verwisselen",
                "step1": {
                    "name": "Upload basisafbeelding",
                    "text": "Upload de foto met het lichaam/de scène die je wilt gebruiken (bijv. een astronaut)."
                },
                "step2": {
                    "name": "Upload gezichtsfoto",
                    "text": "Upload een foto van het gezicht dat je op het lichaam wilt verwisselen."
                },
                "step3": {
                    "name": "Genereren",
                    "text": "Klik op Maken. De AI mengt het nieuwe gezicht naadloos in de basisafbeelding."
                }
            }
        }
    },
    "id": {
        "photoFaceSwap": {
            "title": "Tukar Wajah Foto AI Gratis Online | WeryAI",
            "description": "Tukar wajah di foto secara instan dengan AI. Buat meme lucu, potret artistik, atau avatar profesional. Hasil realistis dalam hitungan detik. Kredit gratis untuk memulai!",
            "keywords": "tukar wajah AI, tukar wajah online, pengubah wajah foto, reface gratis, ganti wajah di gambar, deepfake foto, pembuat meme AI",
            "og_title": "Tukar Wajah Foto AI Gratis Online | WeryAI",
            "og_description": "Tukar wajah di foto secara instan dengan AI. Buat meme lucu, potret artistik, atau avatar profesional. Hasil realistis dalam hitungan detik. Kredit gratis untuk memulai!",
            "twitter_title": "Tukar Wajah Foto AI Gratis Online | WeryAI",
            "twitter_description": "Tukar wajah di foto secara instan dengan AI. Buat meme lucu, potret artistik, atau avatar profesional. Hasil realistis dalam hitungan detik. Kredit gratis untuk memulai!",
            "page": {
                "title1": "Tukar Wajah Foto AI Gratis",
                "title2": "Ingin melihat diri Anda sebagai astronot, bintang film, atau dalam lukisan klasik? Unggah foto dasar dan wajah target, lalu biarkan AI kami memadukan fitur wajah, pencahayaan, dan warna kulit dengan mulus untuk pertukaran wajah yang sangat realistis dalam hitungan detik.",
                "faq": [
                    {
                        "question": "Bisakah saya menggunakan WeryAI Photo Face Swap secara gratis?",
                        "answer": "Bisa! Pengguna baru mendapatkan kredit gratis saat mendaftar tanpa kartu kredit. Anda juga bisa terus mendapatkan kredit gratis melalui check-in harian, menyelesaikan tugas, dan mengundang teman, sehingga Anda dapat terus menggunakan Photo Face Swap tanpa membayar di muka."
                    },
                    {
                        "question": "Apakah data saya aman?",
                        "answer": "Tentu saja. Kami mengutamakan privasi Anda. Foto yang Anda unggah hanya digunakan untuk proses pertukaran wajah dan secara otomatis dihapus dari server kami setelah waktu singkat."
                    },
                    {
                        "question": "Bagaimana cara mendapatkan hasil terbaik?",
                        "answer": "Untuk pertukaran yang paling realistis, pastikan foto dasar dan foto wajah keduanya jelas, menghadap depan, dan memiliki pencahayaan yang baik. Hindari foto di mana wajah terhalang oleh rambut atau tangan."
                    },
                    {
                        "question": "Bisakah saya menukar wajah di foto grup?",
                        "answer": "Saat ini alat kami fokus pada presisi pertukaran wajah tunggal. Untuk foto grup, silakan potong gambar atau gunakan fitur multi-wajah kami yang akan datang."
                    },
                    {
                        "question": "Bisakah saya menggunakan ini untuk meme?",
                        "answer": "Bisa! Sempurna untuk membuat meme lucu. Tukar wajah teman Anda ke poster film atau template meme viral secara instan. Untuk pertukaran wajah video, coba alat <a href=\"/video-face-swap\">Video Face Swap</a> kami."
                    }
                ]
            },
            "faq": [
                {
                    "question": "Bisakah saya menggunakan WeryAI Photo Face Swap secara gratis?",
                    "answer": "Bisa! Pengguna baru mendapatkan kredit gratis saat mendaftar tanpa kartu kredit. Dapatkan lebih banyak kredit melalui check-in harian, tugas, dan mengundang teman."
                },
                {
                    "question": "Apakah data saya aman?",
                    "answer": "Tentu saja. Foto yang diunggah hanya digunakan untuk pertukaran dan dihapus otomatis dari server setelah waktu singkat."
                },
                {
                    "question": "Bagaimana cara mendapatkan hasil terbaik?",
                    "answer": "Pastikan kedua foto jelas, menghadap depan, dan memiliki pencahayaan yang baik. Hindari wajah yang terhalang rambut atau kacamata."
                }
            ],
            "feature_title1": "Mahakarya Artistik",
            "feature_desc1": "Perjalanan waktu: Tukar wajah Anda ke dalam lukisan minyak klasik seperti Mona Lisa atau Girl with a Pearl Earring. Buat avatar vintage unik secara instan.",
            "feature_title2": "Avatar Profesional dan Keren",
            "feature_desc2": "Pekerjaan impian: Lihat diri Anda dalam setelan balap, perlengkapan astronot, atau pakaian bisnis tanpa membeli kostumnya. Sempurna untuk foto profil yang menonjol.",
            "feature_title3": "Pencampuran Sangat Realistis",
            "feature_desc3": "Tanpa efek tempel: Tidak seperti alat potong-tempel sederhana, WeryAI menganalisis sudut, pencahayaan, dan tekstur kulit untuk memastikan wajah yang ditukar terlihat 100% alami.",
            "howto": {
                "name": "Cara Menukar Wajah di Foto Online",
                "step1": {
                    "name": "Unggah Gambar Dasar",
                    "text": "Unggah foto yang berisi tubuh/adegan yang ingin Anda gunakan (misalnya, astronot)."
                },
                "step2": {
                    "name": "Unggah Gambar Wajah",
                    "text": "Unggah foto wajah yang ingin Anda tukar ke tubuh."
                },
                "step3": {
                    "name": "Hasilkan",
                    "text": "Klik Buat. AI akan memadukan wajah baru ke dalam gambar dasar dengan mulus."
                }
            }
        }
    },
    "tr": {
        "photoFaceSwap": {
            "title": "Ücretsiz AI Fotoğraf Yüz Değiştirme Online | WeryAI",
            "description": "Fotoğraflardaki yüzleri AI ile anında değiştirin. Komik memeler, sanatsal portreler veya profesyonel avatarlar oluşturun. Saniyeler içinde gerçekçi sonuçlar. Ücretsiz kredi!",
            "keywords": "yapay zeka yüz değiştirme, yüz değiştirme online, fotoğraf yüz değiştirici, reface ücretsiz, görüntüde yüz değiştir, deepfake fotoğraf, meme yapıcı ai",
            "og_title": "Ücretsiz AI Fotoğraf Yüz Değiştirme Online | WeryAI",
            "og_description": "Fotoğraflardaki yüzleri AI ile anında değiştirin. Komik memeler, sanatsal portreler veya profesyonel avatarlar oluşturun. Saniyeler içinde gerçekçi sonuçlar. Ücretsiz kredi!",
            "twitter_title": "Ücretsiz AI Fotoğraf Yüz Değiştirme Online | WeryAI",
            "twitter_description": "Fotoğraflardaki yüzleri AI ile anında değiştirin. Komik memeler, sanatsal portreler veya profesyonel avatarlar oluşturun. Saniyeler içinde gerçekçi sonuçlar. Ücretsiz kredi!",
            "page": {
                "title1": "Ücretsiz AI Fotoğraf Yüz Değiştirme",
                "title2": "Kendinizi astronot, film yıldızı veya klasik bir tabloda görmek ister misiniz? Bir temel fotoğraf ve hedef yüz yükleyin; yapay zekamız yüz özelliklerini, ışığı ve cilt tonlarını sorunsuz bir şekilde harmanlayarak saniyeler içinde hiper-gerçekçi bir yüz değişimi oluştursun.",
                "faq": [
                    {
                        "question": "WeryAI Photo Face Swap'ı ücretsiz kullanabilir miyim?",
                        "answer": "Evet! Yeni kullanıcılar kayıt sırasında kredi kartı gerekmeden ücretsiz krediler alır. Ayrıca günlük giriş, görev tamamlama ve arkadaş davetleri yoluyla ücretsiz kredi kazanmaya devam edebilirsiniz; böylece Photo Face Swap'ı ön ödeme yapmadan kullanmayı sürdürebilirsiniz."
                    },
                    {
                        "question": "Verilerim güvende mi?",
                        "answer": "Kesinlikle. Gizliliğinizi ön planda tutuyoruz. Yüklediğiniz fotoğraflar yalnızca yüz değiştirme işlemi için kullanılır ve kısa süre sonra sunucularımızdan otomatik olarak silinir."
                    },
                    {
                        "question": "En iyi sonuçları nasıl alırım?",
                        "answer": "En gerçekçi değişim için hem temel fotoğrafın hem de yüz fotoğrafının net, önden ve iyi aydınlatılmış olmasına dikkat edin. Yüzün saç veya ellerle örtüldüğü fotoğraflardan kaçının."
                    },
                    {
                        "question": "Grup fotoğraflarında yüz değiştirebilir miyim?",
                        "answer": "Şu anda aracımız tek yüz değiştirme hassasiyetine odaklanmaktadır. Grup fotoğrafları için lütfen görüntüyü kırpın veya yakında çıkacak çoklu yüz özelliğimizi kullanın."
                    },
                    {
                        "question": "Bunu memeler için kullanabilir miyim?",
                        "answer": "Evet! Komik memeler oluşturmak için mükemmel. Arkadaşınızın yüzünü bir film afişine veya viral meme şablonuna anında yerleştirin. Video yüz değişimi için <a href=\"/video-face-swap\">Video Face Swap</a> aracımıza göz atın."
                    }
                ]
            },
            "faq": [
                {
                    "question": "WeryAI Photo Face Swap'ı ücretsiz kullanabilir miyim?",
                    "answer": "Evet! Yeni kullanıcılar kayıt sırasında kredi kartı gerekmeden ücretsiz krediler alır. Günlük giriş, görevler ve arkadaş davetleri ile de ücretsiz kredi kazanabilirsiniz."
                },
                {
                    "question": "Verilerim güvende mi?",
                    "answer": "Evet. Yüklenen fotoğraflar yalnızca değişim için kullanılır ve kısa süre sonra sunuculardan otomatik olarak silinir."
                },
                {
                    "question": "En iyi sonuçları nasıl alırım?",
                    "answer": "Her iki fotoğrafın da net, önden ve iyi aydınlatılmış olmasına dikkat edin. Saç veya gözlükle örtülü yüzlerden kaçının."
                }
            ],
            "feature_title1": "Sanatsal Başyapıtlar",
            "feature_desc1": "Zaman yolculuğu: Yüzünüzü Mona Lisa veya İnci Küpeli Kız gibi klasik yağlı boya tablolara yerleştirin. Anında benzersiz vintage avatarlar oluşturun.",
            "feature_title2": "Profesyonel ve Havalı Avatarlar",
            "feature_desc2": "Hayalinizdeki iş: Kostüm satın almadan kendinizi yarış kıyafetinde, astronot giysisinde veya iş kıyafetinde görün. Göz alıcı profil fotoğrafları için mükemmel.",
            "feature_title3": "Hiper-Gerçekçi Harmanlama",
            "feature_desc3": "Yapıştırma efekti yok: Basit kes-yapıştır araçlarının aksine, WeryAI açıyı, aydınlatmayı ve cilt dokusunu analiz ederek değiştirilen yüzün %100 doğal görünmesini sağlar.",
            "howto": {
                "name": "Fotoğraflarda Yüzler Nasıl Değiştirilir",
                "step1": {
                    "name": "Temel Görüntüyü Yükle",
                    "text": "Kullanmak istediğiniz gövdeyi/sahneyi içeren fotoğrafı yükleyin (ör. bir astronot)."
                },
                "step2": {
                    "name": "Yüz Görüntüsünü Yükle",
                    "text": "Vücutta değiştirmek istediğiniz yüzün bir fotoğrafını yükleyin."
                },
                "step3": {
                    "name": "Oluştur",
                    "text": "Oluştur'a tıklayın. Yapay zeka yeni yüzü temel görüntüye sorunsuz bir şekilde harmanlayacaktır."
                }
            }
        }
    }
}
